import { getConfig } from '@local/app-config';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getCombinedToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import type { ErrorResponse } from '../types';

const identityBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError | ErrorResponse
> = async (args, WebApi, extraOptions) => {
    const identityBaseUrl = getConfig().identity_url;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl: identityBaseUrl,
    });
    const result = await rawBaseQuery(args, WebApi, extraOptions);
    if (result.error) {
        getCombinedToken();
    }
    return result;
};

export const IdentityApiClient = createApi({
    reducerPath: 'identityAPI',
    baseQuery: identityBaseQuery,
    endpoints: () => ({}),
});
